import { Link } from "react-router-dom";
import "./ArrowButton.scss";
import rightArrow from "./images/right-arrow-blue-new.svg";
import leftArrow from "./images/left-arrow-blue-new.svg";

function ArrowButton({ to, side }: { to: string; side: string }) {
  return (
    <Link to={to} className={`button-circle-${side}`}>
      {side === "right" && (
        <img src={rightArrow} alt="right arrow" className="img-fill" />
      )}
      {side === "left" && (
        <img src={leftArrow} alt="left arrow" className="img-fill" />
      )}
    </Link>
  );
}

export default ArrowButton;
